﻿@if (column.sortColumn) {
  <a (click)="onColumnClick(column)">{{formatService.translateAndFormat(column.title)}}</a>
}
@if (!column.sortColumn && column.title) {
  <span>{{formatService.translateAndFormat(column.title)}}</span>
}
@if (column.type) {
  <input type="{{column.type}}" class="centered" (click)="toggleSelectAll()">
}
@if (column.sortColumn === currentSortColumn) {
  <a (click)="changeSortDirection()">
    <i class="fa" [ngClass]="{'fa-caret-up' : !desc, 'fa-caret-down' : desc }" style="padding-right:5.14px;"></i>
  </a>
}
